<div class="col-md-12">
    <div class="form-group">
        <p>Select sitting type:</p>
        <div style="margin-top: 20px;">
            <input
                type="radio"
                name="sittingType"
                [(ngModel)]="showPrivateSittings"
                (change)="toggleTestType()"
                [value]="false"
                class="mr-2"
            />
            <label>
                <strong><span *ngIf="webDelivery">Public Online Test Date</span><span *ngIf="!webDelivery">Public Sitting</span></strong>
            </label>
            <p style="margin-top: 10px">
                All candidates can register to write the {{testName}} at a public sitting.
            </p>
        </div>
        <hr>
        <div style="margin-top: 10px;">
            <input
                type="radio"
                name="sittingType"
                [(ngModel)]="showPrivateSittings"
                (change)="toggleTestType()"
                [value]="true"
                class="mr-2"
            />
            <label>
                <strong>Special Accommodation<span *ngIf="webDelivery"> Online </span>Sitting</strong>
            </label>
            <p style="margin-top: 10px">
                If you have been approved for a Special Accommodation Test Sitting, please register for the test below.
                <br />
                If you have not yet been approved, please <a
                    href={{faqUrl}}
                    target="_blank"
                >see here for more information</a>.
            </p>
        </div>
    </div>
</div>
